import React from 'react';
import PropTypes from 'prop-types';

import { useSettings } from 'hooks/useSettings';

/**
 * @typedef {object} BackImageProps
 * @property {boolean} blur - Whether the image should be blurred.
 * @property {boolean} darken - Whether the image should be darkened.
 */

/**
 * @param {BackImageProps} props Configuration props for BackImage.
 * @returns {JSX.Element} The BackImage component.
 */
const BackImage = ({ blur = false, darken = false }) => {
  const { appInfo: { generalBackgroundImage, backgroundImages } = {} } = useSettings();

  const matchingBackgroundImage = backgroundImages?.find((image) => window.location.pathname.includes(image?.regex));

  const img = matchingBackgroundImage?.image || generalBackgroundImage || null;

  return (
    <div className="back-image__wrapper">
      {img && (
        <div
          style={{ backgroundImage: `url(${img.replace('front.travpromobile.com', 'travprocdn.imgix.net')}?w=1500)` }}
          className={`backgroundImage ${blur && 'blur'} ${darken && 'darken'}`}
        />
      )}
    </div>
  );
};

export default BackImage;

BackImage.propTypes = {
  blur: PropTypes.bool,
  darken: PropTypes.bool,
};
